import { render, staticRenderFns } from "./DeliveryLogPayloadResponseModal.vue?vue&type=template&id=5bd2702a&scoped=true"
import script from "./DeliveryLogPayloadResponseModal.vue?vue&type=script&lang=ts"
export * from "./DeliveryLogPayloadResponseModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2702a",
  null
  
)

export default component.exports